import { RootState } from "../../app";

const selectGroupBlockCounts = (state: RootState) =>
  state.configMapReducer.groupBlock.groupBlockCount;

export default selectGroupBlockCounts;
